import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route, NavLink } from 'react-router-dom';
import classes from './HomeView.module.scss';
import LoginDialog from './LoginDialog';
import Button from './Button';
import CircleLoader from './CircleLoader';
import { history, RootState } from '../reducers/store';
import { getUserInfo } from '../service/userService';
import WsConnection from '../service/WsConnection';
import { setFirstConnect } from '../reducers/firstConnectReducer';

const HomeView: FC<{ PageCover: FC; title: string }> = ({ PageCover, title }) => {
  const dispatch = useDispatch();
  const firstConnect = useSelector((state: RootState) => state.firstConnect);
  // true while login (getUserInfo) and/or the websocket handshake are in progress
  const [connecting, setConnecting] = useState(false);
  const mounted = useRef(true);
  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  const loadUserAndConnect = useCallback(() => {
    setConnecting(true);
    getUserInfo()
      .then(() => WsConnection.connect())
      .catch(() => {
        // login failed or socket never opened -> show the login dialog
        history.push('/login');
      })
      .finally(() => {
        if (mounted.current) setConnecting(false);
      });
  }, []);

  // auto connect
  useEffect(() => {
    dispatch(setFirstConnect(false));
    if (firstConnect) {
      loadUserAndConnect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [firstConnect]);

  const handleConnect = () => {
    //  load userinfo then connect, otherwise show login dialog
    loadUserAndConnect();
  };

  const handleLogin = () => {
    history.push('/login');
  };

  return (
    <div className={classes.mainCont}>
      <Route exact path="/login">
        <LoginDialog />
      </Route>
      <h1 className={classes.title}>{title}</h1>
      <span>Online, multiplayer board games</span>
      <PageCover />
      <div className={classes.btnBar}>
        <Button onClick={handleConnect} loading={connecting}>
          Connect
        </Button>
        <Button onClick={handleLogin}>Login</Button>
        <span className={classes.loaderSlot}>{connecting && <CircleLoader size={20} />}</span>
      </div>
      <div className={classes.btnBar}>
        <NavLink to="/privacypolicy">Privacy policy</NavLink>
      </div>
    </div>
  );
};
export default HomeView;
